var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "filogix-details-modal",
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
      "modal-dialog-size": "lg",
    },
    on: { show: _vm.handleShow, hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("settings.accountTab.lenderSubmissionDetails")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.modalOpened
              ? [
                  _c("i18n", {
                    attrs: {
                      tag: "p",
                      path: "direct-to-lender.creditBureau.completeFieldsMessage",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "section",
                          fn: function () {
                            return [
                              _c("strong", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("global.doorr.personalSettings")
                                    ) +
                                    "\n          "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3506274494
                    ),
                  }),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      attrs: { id: "filogix-details-form" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.handleSubmit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c("filogix-details-form", {
                            attrs: { "require-lender-submission-details": "" },
                            model: {
                              value: _vm.filogixDetails,
                              callback: function ($$v) {
                                _vm.filogixDetails = $$v
                              },
                              expression: "filogixDetails",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "button",
              {
                ref: "submitButton",
                staticClass:
                  "btn btn-sm btn-primary filogix-details submit-changes move-on",
                attrs: { type: "submit", form: "filogix-details-form" },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("application.actions.saveAndContinue")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }